import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./primary-nav.css?inline";

@customElement("eko-primary-nav")
class PrimaryNav extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<ul class="eko-primary-nav">
      <slot></slot>
    </ul>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-primary-nav": PrimaryNav;
  }
}

export default PrimaryNav;
